import countries from '../assets/countries.json'

export default async ({ Vue }) => {
  const myIcons = {
    aplyid: 'img:custom_icons/aplyid.png',
    rebit: 'img:custom_icons/rebit.svg',
    'my:r-w': 'img:custom_icons/r-w.svg',
    'my:r-p': 'img:custom_icons/r-p.svg',
    usdt: 'img:custom_icons/tether.svg',
    'deposit-withdrawal': 'img:custom_icons/wiki-icons/deposit-withdrawal.svg',
    'personal-support': 'img:custom_icons/wiki-icons/personal-support.svg',
    certificate: 'img:custom_icons/wiki-icons/certificate.svg',
    'invest-pot': 'img:custom_icons/wiki-icons/invest-pot.svg',
    deal: 'img:custom_icons/wiki-icons/deal.svg',
    man: 'img:custom_icons/wiki-icons/man.svg',
    bitcoin: 'img:custom_icons/wiki-icons/bitcoin.svg',
    exchange: 'img:custom_icons/wiki-icons/exchange.svg',
    'my:support-white': 'img:custom_icons/wiki-icons/support-w.svg',
    'my:support-primary': 'img:custom_icons/wiki-icons/support-p.svg',
    'trustpilot-star': 'img:custom_icons/trustpilot-star.svg',
    poli: 'img:custom_icons/poli-logo-white.svg',
    finmo: 'img:custom_icons/finmo.svg'
  }

  for (const i in countries) {
    const country = countries[i]
    myIcons[country.code] = 'img:custom_icons/flags/' + country.code + '.svg'
  }

  Vue.prototype.$q.iconMapFn = (iconName) => {
    const icon = myIcons[iconName]
    // eslint-disable-next-line no-void
    if (icon !== void 0) {
      return { icon: icon }
    }
  }
}
